import React from 'react';
import styled from 'styled-components';

import FooterDiv1  from './FooterDiv1';
import imgLogoFooter from '../../images/logosinfondo.png';
import imgFaunaFooter from '../../images/todo/fauna1.png';
import imgFaunaFooter2 from '../../images/todo/fauna2.png';


const FooterInicio = () => {
    return(
        <FooterInicioCSS>
           <FooterDiv1></FooterDiv1>
           <FooterDiv2CSS>
            <img src = {imgLogoFooter} alt="/"/>
           </FooterDiv2CSS>
           <FooterDiv3CSS>
            <img src = {imgFaunaFooter} alt="/"/>
            <img src = {imgFaunaFooter2} alt="/"/>
            <h4>Somos Promotores del Turismo Nacional y Defensores del Medio Ambiente</h4>
            <h2> Club Ecoturístico Flor del Guaviare</h2>
            <h3> Juntos Haremos del Turismo <br></br>un Negocio Rentable</h3>
           </FooterDiv3CSS>
           <div className =" textFooter2">
               <h4>©Copyright - InviertaBien S.A.S &nbsp;&nbsp;2021</h4>
           </div>
        </FooterInicioCSS>
    )
}
export default FooterInicio;

const FooterInicioCSS = styled.footer`
  height: 20%;
  width: 100%;
  margin: 0%;
  position:relative;
  top:-2%;
  background-color: #282c34;
  display: flex;
  justify-content: center;
  @media(max-width: 1024px) {
    display: flex;
    height:20%;
  }
  @media(max-width: 768px) {
    display: block;
    height:80%;
    top: -1%;
  }
  @media(max-width: 680px) {
    height:75%;
    top: -1%;
    }
    @media(max-width: 620px) {
    height:70%;
    top: -1%;
    }
    @media(max-width: 550px) {
    height:65%;
    top: -1%;
    }
  @media(max-width: 480px) {
    display: block;
    height:60%;
    top: -1%;
  }
  @media(max-width: 450px) {
    display: block;
    height:58%;
    top: -1%;
  }
  @media(max-width: 320px) {
    display: block;
    height:55%;
    top: 0%;
  }
  .textFooter2 {
      color: #fff;
      float: center;
      position: absolute;
      bottom:0%;
      font-family: widen latin;
      margin: auto;
      @media(max-width: 1024px) {
          width: 100%;
      }
      @media(max-width: 768px) {
          width: 100%;
      }
      @media(max-width: 480px) {
          width: 100%;
      }
      @media(max-width: 320px) {
          width: 100%;
      }
  }
`;

const FooterDiv2CSS = styled.div`
    width: 33.3%;
    @media(max-width: 1024px) {
        width: 33.3%;
        margin-bottom:0%;
    }
    @media(max-width: 768px) {
        width: 100%;
        margin-bottom:0%;
    }
    @media(max-width: 730px) {
        margin-bottom:4%;
    }
    @media(max-width: 480px) {
        width: 100%;
        margin-bottom:10%;
    }
    @media(max-width: 320px) {
        width: 100%;
        margin-bottom:10%;
    }
    img {
        position: relative;
        width: 60%;
        
        @media(max-width: 768px) {
        width: 45%;
    }
    }
`;
const FooterDiv3CSS = styled.div`
    width: 33.3%;
    box-shadow: 2px 3px 3px 3px green;
    @media(max-width: 768px) {
        width: 100%;
    }
    @media(max-width: 480px) {
        width: 100%;
    }
    @media(max-width: 320px) {
        width: 100%;
    }
    img {
        position: relative;
        width: 20%;
    }
    h4 {
        color: white;
        font-family: widen latin;
        margin: 1%;        
    }
    h2 {
        font-family: widen latin;
        color: green;
    }
    h3 {
        font-family: widen latin;
        color: black;
    }
`;

